const voucherRoutes = {
  path: 'vouchers',
  name: 'vouchersOverview',
  components: {
    default: () => import('@/views/PageRoutView')
  },
  redirect: { name: 'vouchers' },
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: '/:channelId/vouchers',
      name: 'vouchers',
      component: () => import('@/views/Vouchers/Vouchers'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:channelId/vouchers/:voucherId',
      name: 'vouchers-detail',
      component: () => import('@/views/Vouchers/VoucherDetail'),
      meta: {
        requiresAuth: true
      }
    },
  ]
}

export default voucherRoutes
